import { createContext, useContext } from "react";

/** Whether the merchant uses the new returns settings page, not the old pages. */
export const ReturnsNewSettingsContext = createContext(false);

export function useReturnsNewSettings(): boolean {
  return useContext(ReturnsNewSettingsContext);
}
